import React from 'react';
import { Tooltip, Icon, Tag } from 'antd';
import s from '../AnnualReviewReport.module.scss';

const getDisplayValue = (value, format) => {
  if (value == null) return '—';
  if (typeof value === 'number') {
    return format === 'percentage' ? `${value}%` : value.toLocaleString();
  }
  return value;
};

const getTagColor = healthColor => {
  if (healthColor === 'green') return 'green';
  if (healthColor === 'red') return 'red';
  return null;
};

const MetricRow = ({ label, value, tooltip, healthColor, format }) => {
  const displayValue = getDisplayValue(value, format);
  const tagColor = getTagColor(healthColor);

  return (
    <div className={s.metricRow} role="row">
      <span className={s.metricLabel}>
        {label}
        {tooltip && (
          <Tooltip title={tooltip}>
            <Icon
              type="info-circle"
              style={{ color: '#8c8c8c', cursor: 'help', marginLeft: 4 }}
              aria-label={`More info about ${label}`}
            />
          </Tooltip>
        )}
      </span>
      <span className={s.metricValue}>
        {displayValue}
        {tagColor && (
          <Tag
            color={tagColor}
            className={s.metricHealthTag}
            aria-label={`Health: ${healthColor}`}
          >
            {healthColor}
          </Tag>
        )}
      </span>
    </div>
  );
};

export default MetricRow;
